import { opinionData, opinionTrend } from "@/mocks/gua";

export default function Opinion() {
  return (
    <section className="mt-16 px-4 md:mt-24 md:px-6">
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-6 lg:grid-cols-5">
        {/* 左：立场分布 */}
        <div className="lg:col-span-3">
          <div className="rounded-xl border border-background-200 bg-background-100/50 p-5 md:p-6">
            <div className="mb-5 flex flex-wrap items-center justify-between gap-2">
              <div>
                <p className="mb-1 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-accent-600">
                  <i className="ri-pie-chart-2-line" /> 舆论风向
                </p>
                <h2 className="font-heading text-xl font-bold text-foreground-950">
                  围观的人，到底站在哪一边？
                </h2>
              </div>
              <span className="rounded-md bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">
                抽样自 12.6 万条讨论
              </span>
            </div>

            <div className="flex flex-col gap-4">
              {opinionData.map((o) => (
                <div key={o.stance} className="flex flex-col gap-1.5">
                  <div className="flex items-center justify-between text-sm">
                    <span className="font-medium text-foreground-800">
                      {o.stance}
                      <span className="ml-2 rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">
                        {o.tag}
                      </span>
                    </span>
                    <span className="font-heading text-sm font-bold text-primary-600">{o.ratio}%</span>
                  </div>
                  <div className="h-2 overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-full rounded-full ${o.ratio > 30 ? "bg-accent-500" : "bg-secondary-400"}`}
                      style={{ width: `${o.ratio}%` }}
                    />
                  </div>
                  <p className="text-xs text-foreground-500">{o.tone}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 右：趋势指标 */}
        <div className="lg:col-span-2">
          <div className="flex h-full flex-col justify-between gap-4 rounded-xl bg-accent-500 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold text-background-50">热度正在如何降温</h3>
              <i className="ri-line-chart-line text-2xl text-background-50/80" />
            </div>
            <div className="flex flex-col gap-5">
              {opinionTrend.map((t) => (
                <div key={t.label}>
                  <div className="flex items-baseline justify-between">
                    <span className="text-sm text-background-50/85">{t.label}</span>
                    <span className="font-heading text-2xl font-bold text-background-50">{t.value}%</span>
                  </div>
                  <p className="mt-1 text-xs text-background-50/75">{t.note}</p>
                </div>
              ))}
            </div>
            <p className="border-t border-background-50/20 pt-3 text-xs leading-relaxed text-background-50/80">
              当我们把「情绪」翻译成「数据」，会发现每一次反转背后都有可解释的传播规律。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}